import React from 'react'
import Card from 'react-bootstrap/Card'
import { Link } from "react-router-dom"
import moment from 'moment'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { useContentfulEntry } from '../../hooks/useContentfulEntry'

function BlogPostSummary({ id, headlineImage }) {
  const { entry, loading, error } = useContentfulEntry(id)

  if (loading) return null
  if (error) return null
  if (!entry || !entry.items || entry.items.length === 0) return null

  const article = entry.items[0]

  let publishedAt = article.fields.displayDate
    ? moment(article.fields.displayDate)
    : moment(article.sys.updatedAt)

  const imageSource = article.fields.image && article.fields.image.fields.file
    ? article.fields.image.fields.file.url
    : headlineImage

  const url = ('/blog/' + article.fields.url).replace('//', '/')

  return (
    <div className="card mb-3 item-left-hand-image">
      <div className="row g-1">
        <div className="col-md-4">
          {imageSource &&
            <img
              src={imageSource}
              alt={article.fields.altText}
              style={{ width: '100%', objectFit: 'cover', objectPosition: 'center', height: 200 }}
            />
          }
        </div>
        <div className="col-md-8">
          <h3><Link to={url}>{article.fields.heading}</Link></h3>
          <Card.Body style={{ textOverflow: 'ellipsis', overflow: 'hidden', maxHeight: '6rem' }}>
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {article.fields.body}
            </ReactMarkdown>
          </Card.Body>
          <Card.Footer>
            <small className="text-muted">{publishedAt.fromNow()}</small>
          </Card.Footer>
        </div>
      </div>
    </div>
  )
}

export default BlogPostSummary
